/* eslint-disable @typescript-eslint/no-explicit-any */
import { waitForCondition } from '@marriott/shared/mi-helper-utils';

type PointsSession = {
  mvDelegate: string;
  transactionQuantity: number;
  redemptionQuantity: number;
  language: string;
};

const PTS = 'PTS';
const SESSION = 'session';

/**
 * Sets the points session on the global window object.
 *
 * @param session - The PointsSession object to set.
 */
export const setPointsSession = (session: PointsSession) => {
  window[PTS] = window[PTS] ?? {};
  window[PTS][SESSION] = session;
};

/**
 * Waits for the points session delegate to be available on the window object,
 * then opens the <pts-modal> element if it exists in the DOM.
 *
 * @returns A Promise that resolves when the modal is opened or does nothing if
 *     the modal is not found.
 */
export const openPointsModal = async () => {
  try {
    await waitForCondition(() => !!window[PTS] && !!window[PTS]['session'] && !!window[PTS]['session']?.['mvDelegate']);
    const ptsModal = document.querySelector('pts-modal') as (HTMLElement & { open: () => void }) | null;
    if (ptsModal) {
      ptsModal.open();
    }
  } catch (err) {
    console.warn('Points modal could not be opened:', err);
  }
};
